module.exports = __WEBPACK_EXTERNAL_MODULE_57__;


//////////////////
// WEBPACK FOOTER
// external "$"
// module id = 57
// module chunks = 67